<template>
    <div class="container-background">
        <div class="container-header">
            <v-btn class="container-botao-voltar" depressed flat @click="voltar">
                <v-icon color="#EEEEEE">arrow_back</v-icon>
            </v-btn>
            <span class="text-header">Compras BR</span>
        </div>
        <div class="container-card">
            <div class="card-item" v-for="item in planos" :key="item.id">
                <div>
                    <div class="card-header-plano-atual" v-if="item.id == assinaturaAtual.planoProduto.id">
                        <span>PLANO ATUAL</span>
                    </div>
                    <div class="card-header">
                        <span class="card-text-header">{{ item.nome }}</span>
                    </div>
                    <div class="card-body-valor">
                        <span class="card-text-valor">{{ item.valor | valorParaReal }}</span>
                        <span class="card-text-ciclo">{{ item.ciclo | azEnum(tiposCiclosPlanoAssinatura)}}</span>
                    </div>
                    <div class="card-body body-text">
                        <span>{{ item.descricao }}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <v-btn v-if="item.id == assinaturaAtual.planoProduto.id && !cobrancaPagar && !planoEstaExpirado"
                           depressed class="btn-card-item-pagar" color="#3a6861" disabled>Pago
                    </v-btn>
                    <v-btn v-if="item.id == assinaturaAtual.planoProduto.id && cobrancaPagar"
                           depressed class="btn-card-item-pagar" color="#3a6861" @click="pagarPlano(cobrancaPagar)">
                        Pagar
                    </v-btn>
                    <v-btn v-if="item.id == assinaturaAtual.planoProduto.id && planoEstaExpirado"
                           depressed class="btn-card-item-pagar" color="#3a6861" @click="selecionarPlano(item)">
                        Renovar
                    </v-btn>
                    <v-btn v-if="item.id != assinaturaAtual.planoProduto.id" depressed class="btn-card-item"
                           color="#3a6861" @click="selecionarPlano(item)" :disabled="!dadosCarregados"
                           :loading="carregamento">
                        Selecionar
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {actionTypes, tiposCiclosPlanoAssinatura} from '@/commons/constants'

    export default {
        name: 'TelaPlanos',
        data() {
            return {
                tiposCiclosPlanoAssinatura,
                planos: [],
                assinaturaAtual: {planoProduto: {id: null}},
                cobrancaPagar: null,
                planoEstaExpirado: false,
                dadosCarregados: null,
                carregamento: false
            }
        },
        async mounted() {
            this.carregamento = true
            this.verificarUsuarioFornecedor()
            await this.buscarPlanos()
            await this.buscarAssinaturaAtual()
            await this.buscarTodasCobrancasPorAssinatura()
            this.dadosCarregados = true
            this.carregamento = false
        },
        methods: {
            ...mapActions([
                actionTypes.BUSCAR_DADOS_ASSINATURAS_FORNECEDOR,
                actionTypes.BUSCAR_PLANOS_FORNECEDOR,
                actionTypes.BUSCAR_COBRANCAS_POR_ASSINATURA,
            ]),
            async buscarPlanos() {
                const {items} = await this.buscarPlanosFornecedor()
                this.planos = items
            },
            async buscarAssinaturaAtual() {
                const {assinaturaAtual, ultimaAssinaturaExpirada, assinaturaPendente} = await this.buscarDadosAssinaturasFornecedor()
                if (assinaturaAtual) {
                    this.assinaturaAtual = assinaturaAtual
                } else if (assinaturaPendente) {
                    this.assinaturaAtual = assinaturaPendente
                } else if (ultimaAssinaturaExpirada) {
                    this.assinaturaAtual = ultimaAssinaturaExpirada
                    this.planoEstaExpirado = true
                } else {
                    this.assinaturaAtual = {id: null, planoProduto: {id: null}}
                }
            },
            async buscarTodasCobrancasPorAssinatura() {
                if (this.assinaturaAtual.id && !this.planoEstaExpirado) {
                    const response = await this.buscarCobrancasPorAssinatura(this.assinaturaAtual.id)
                    this.cobrancaPagar = response.items.find(item => !item.dataPagamento)
                }
            },
            selecionarPlano(plano) {
                this.$router.push({name: 'selecionarPagamento', params: {idPlano: plano.id}})
            },
            pagarPlano(cobranca) {
                if (cobranca.tipoPagamento === 'BOLETO') {
                    window.open(cobranca.urlBoleto, '_blank');
                } else {
                    window.open(cobranca.urlFatura, '_blank');
                }
            },
            verificarUsuarioFornecedor() {
                if (this.$store.state.loki.user.type !== 'EXTERNO') {
                    this.$router.push({name: 'licitacaoBusca'})
                }
            },
            voltar() {
                this.$router.push({name: 'PlanoFaturas'})
            }
        }
    }
</script>

<style scoped lang="stylus">

    .container-background
        height 100vh
        background-color #EEEEEE
        font-family Roboto, sans-serif
        line-height 1.5

    .container-header
        display flex
        align-items center
        height 50px
        background-color #3a6861
        color #EEEEEE

    .container-botao-voltar
        height 100%
        padding 0px
        margin 0px
        margin-right 20px
        border-right 2px solid rgba(12, 36, 56, 0.5)

    .text-header
        font-size 20px
        font-weight 400

    .container-card
        height 100vh
        padding-top 80px
        display grid
        grid-template-columns 315px 315px 315px
        grid-template-rows 515px 515px 515px
        align-items center
        justify-content center

    .card-item
        width 300px
        height 500px
        margin-right 30px
        border-radius 10px
        display flex
        flex-direction column
        justify-content space-between
        align-items center
        background-color #FFFFFF
        word-break break-word

    .card-header-plano-atual
        width 300px
        text-align center
        font-size 20px
        font-weight 600
        color #FFFFFF
        background-color #3a6861
        border-top-left-radius 10px
        border-top-right-radius 10px
        padding 10px 0px

    .card-header
        text-align center
        margin 0 auto
        width 250px
        border-bottom-width 1px
        border-bottom-style solid
        border-bottom-color #ccc
        box-sizing border-box
        padding-top 15px
        padding-bottom 15px


    .card-body-valor
        display flex
        flex-direction column
        justify-content center
        align-items center
        margin-top 10px

    .card-body
        display flex
        flex-direction column
        align-items center
        justify-content center
        margin-top 20px

    .body-text
        text-align center
        font-size 18px
        color #777777

    .card-text-header
        font-size 20px
        font-weight 600
        color #3a6861

    .card-text-valor
        font-size 40px
        font-weight 600
        color #3a6861

    .card-text-ciclo
        font-size 18px
        font-weight 600
        color #3a6861

    .card-footer
        display flex
        justify-content center
        width 250px
        border-top-width 1px
        border-top-style solid
        border-top-color #ccc
        box-sizing border-box
        margin-top 5%
        padding-top 15px
        padding-bottom 15px

    .btn-card-item
        color white !important
        border-radius 5px

    .btn-card-item-pagar
        width 114.73px
        color white !important
        border-radius 5px

</style>